import { Flex } from "antd";
import ButtonStyle01 from "../button-style01/ButtonStyle01.component";
import Event from "../event/Events.component";
import ImageCarousel from "../image-carousel/image-carousel.component";
import "./Main.styles.scss";

/***   Assets ****/
import IMAGES from "../imagesVariable/imagesVariable";

const quickLinks = [
  
    {
    img: IMAGES.bookYourSlot,
    name: "Booking slot for 1st year student.",
    link: "https://docs.google.com/forms/d/1ZwxPIDt3ZVJCoTNe1GjiylcA1YG94yjP2Dmwtpt8U90/edit",
    isBlink: false
  },
  {
    img: IMAGES.thesis2,
    name: "Thesis Submission",
    link: "https://docs.google.com/forms/d/e/1FAIpQLSeKnyU7XnzNpdcAPRe8XflJPbRL2GUg4N49nbJbDsM3Tu_rnw/viewform",
    isBlink: false
  },
  {
    img: IMAGES.citizensCharter,
    name: "Citizen's Charter",
    link: "/citizen_charter",
    isBlink: false
  },
  {
    img: IMAGES.idCard,
    name: "Id Card",
    link: "/id_card",
    isBlink: false
  },

  {
    img: IMAGES.remote,
    name: "Remote Access",
    link: "https://my.openathens.net/?passiveLogin=false",
    isBlink: false
  },

];

const Main = () => (
  <main>
    <div>
      <Flex className="responsive-flex">
        <div className="responsive quick-links-section mobile-order-2">
          <Event events={quickLinks} Title={""} />
        </div>
        <div className="carousel-section">
        <ImageCarousel
          images={[
            {
              url: IMAGES.banner4
            },
            {
              url: IMAGES.banner1,
            },
            {
              url: IMAGES.banner2,
            },
            {
              url: IMAGES.banner3,
            }
            
          ]}
        />
        </div>
        {/* <div className="mobile-order-2">
        

        <ButtonStyle01
        buttonText="View All Digital Resources"
        buttonLink="/a-z-database"
        />
        <br />
          </div> */}
      </Flex>
    </div>
  </main>
);

export default Main;
